<template>
  <div class="w100 pb10">
    <el-table class="w100 tx-c" :data="list" stripe border row-class-name="cu-p" empty-text="暂无可评价记录" height="600px" @row-click="clickRowItem">
      <el-table-column label="发起人" prop="createUserName" resizable align="center"></el-table-column>
      <el-table-column label="发起时间" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结办时间" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="耗时" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.costTimes | costTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="60">
        <template slot-scope="scope">
          <span class="blue cu-p" v-if="!scope.row.cstate" @click="showJudge(scope.row, false)">评论</span>
          <span class="grey cu-p" v-else @click="fetchJudge(scope.row)">已评</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing" width="1000px">
      <span class="font-16" slot="title">{{ selData.serveName }}</span>
      <div class="w100">
        <div class="w100 flex-box">
          <div class="pr10">服务时长</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreDuration" :disabled="isJudge" allow-half show-score :score-template="String(selData.scoreDuration * 2)"></el-rate>
          </div>
        </div>
        <div class="w100 pt10 flex-box">
          <div class="pr10">服务质量</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreQuality" :disabled="isJudge" allow-half show-score :score-template="String(selData.scoreQuality * 2)"></el-rate>
          </div>
        </div>
        <el-input class="w100 mt20" type="textarea" :rows="5" placeholder="请输入内容" v-model="selData.comment" :readonly="isJudge"></el-input>
      </div>
      <span slot="footer" v-if="!isJudge">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="warning" :disabled="this.selData.comment == '' || this.selData.scoreDuration == 0 || this.selData.scoreQuality == 0" :loading="updataing" @click="addJudege">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ServerInfoCollect",
  props: {
    appName: String
  },
  data() {
    return {
      loading: false,

      list: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      updataing: false,
      isJudge: false,
      selData: {
        serveId: "",
        serveName: this.$route.query.serveTitle || this.appName,
        processInstId: "",
        comment: "",
        scoreDuration: 0,
        scoreQuality: 0
      }
    };
  },
  computed: {},
  mounted() {
    this.fetchData();
  },
  methods: {
    clickRowItem(row) {
      if (!row.cstate) {
        this.showJudge(row, false);
      } else {
        this.fetchJudge(row);
      }
    },
    fetchData() {
      this.fetchList();
    },
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          "task/findDoneTaskPage",
          this.$qs.stringify({
            serveId: this.$route.query.id,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetStatus == 0 && data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    addJudege() {
      if (
        this.selData.comment == "" ||
        this.selData.scoreDuration == 0 ||
        this.selData.scoreQuality == 0
      ) {
        this.$message({
          message: "内容不能为空且至最低分为1分",
          type: "error"
        });
        return;
      }

      this.updataing = true;
      this.$http
        .post(
          "serveComment/save",
          this.$qs.stringify({
            serveId: this.selData.serveId,
            serveName: this.selData.serveName,
            processInstId: this.selData.processInstId,
            comment: this.selData.comment,
            scoreDuration: this.selData.scoreDuration * 2,
            scoreQuality: this.selData.scoreQuality * 2
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.RetStatus == 0 && data.RetCode) {
            this.$message({
              message: data.RetData,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }

          this.updataing = false;
          this.isShow = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.updataing = false;
          this.isShow = false;
        });
    },
    showJudge(obj, isJudge) {
      // console.log(obj);
      this.selData.serveId = obj.processDefId;
      // this.selData.serveName = obj.processDefName;
      this.selData.processInstId = obj.processInstId;
      if (isJudge) {
        this.selData.comment = obj.comment;
        this.selData.scoreDuration = obj.scoreDuration;
        this.selData.scoreQuality = obj.scoreQuality;
      } else {
        this.selData.comment = "";
        this.selData.scoreDuration = 0;
        this.selData.scoreQuality = 0;
      }

      this.isJudge = isJudge;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    fetchJudge(obj) {
      this.loading = true;

      this.$http
        .post(
          "serveComment/getComment",
          this.$qs.stringify({
            processInstId: obj.processInstId
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetStatus == 0 && data.RetCode) {
            const obj = {
              processDefId: data.RetData.processInstId,
              processDefName: data.RetData.processDefName,
              processInstId: data.RetData.processInstId,
              comment: data.RetData.comment,
              scoreDuration: data.RetData.scoreDuration / 2,
              scoreQuality: data.RetData.scoreQuality / 2
            };
            this.showJudge(obj, true);
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  }
};
</script>
